import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Blocks authenticated users from guest-only pages (login/register).
 * Sends them back where they came from, or home.
 */
const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p style={{ textAlign: "center", padding: "3rem" }}>Loading...</p>;
  }

  if (isAuthenticated) {
    const redirectTo = location.state?.from || "/";
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default GuestRoute;
